// The display preferences of a staff member (density, sidebar), kept in this browser only (`localStorage`). The staff app has one colour
// theme (macOS Light), so there is no theme key. A `lafayette-admin-theme` value that an older version stored is never read.

export const DENSITY_STORAGE_KEY = "lafayette-admin-density";
export const SIDEBAR_STORAGE_KEY = "lafayette-admin-sidebar";

export function readStored(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    // Storage is blocked (private mode, a policy): the default applies.
    return null;
  }
}

export function writeStored(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // The choice then lasts for this visit only.
  }
}
